module.exports = __webpack_public_path__ + "assets/retina_HexagonBySideDetailed.e33a07882dda5caf6f40c83f07751013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_HexagonBySideDetailed.png
// module id = 675
// module chunks = 0